import React from 'react';

function Hero() {
  return (
    <div id="home" className="relative pt-16 overflow-hidden min-h-screen">
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover scale-105 transform-gpu"
        >
          <source
            src="https://player.vimeo.com/external/434045526.hd.mp4?s=81d4eae31b44c8f5f3766957785aa03f1f634676&profile_id=175"
            type="video/mp4"
          />
          Il tuo browser non supporta i video HTML5.
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/75 to-gray-900/60"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/40 to-transparent"></div>
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-pink-600/40 via-transparent to-transparent opacity-70"></div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-purple-600/40 via-transparent to-transparent opacity-70"></div>
        </div>
        <div className="absolute inset-0 bg-[conic-gradient(from_90deg_at_50%_0%,_var(--tw-gradient-stops))] from-pink-500/30 via-transparent to-transparent opacity-50"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white/5 via-transparent to-transparent mix-blend-overlay"></div>
      </div>
      <div className="relative max-w-7xl mx-auto py-32 px-4 sm:py-48 md:py-56 lg:py-64 sm:px-6 lg:px-8">
        <div className="relative max-w-4xl mx-auto text-center">
          <div className="relative inline-block">
            <span className="absolute -inset-4 bg-gradient-to-r from-pink-600/40 to-purple-600/40 blur-2xl rounded-full animate-pulse"></span>
            <span className="absolute -inset-8 bg-gradient-to-r from-pink-400/30 to-purple-400/30 blur-3xl rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></span>
            <span className="absolute -inset-12 bg-gradient-to-r from-pink-300/20 to-purple-300/20 blur-3xl rounded-full animate-pulse" style={{ animationDelay: '1s' }}></span>
            <h1 className="relative text-5xl font-black tracking-tight text-transparent bg-clip-text bg-gradient-to-br from-white via-pink-100 to-purple-200 sm:text-6xl lg:text-7xl xl:text-8xl animate-fade-in px-4 sm:px-0 drop-shadow-2xl leading-tight">
            Rendi Speciale<br />il Tuo Evento
            </h1>
          </div>
          <div className="mt-8 relative">
            <span className="absolute -inset-4 bg-gradient-to-r from-pink-600/20 to-purple-600/20 blur-2xl rounded-full"></span>
            <p className="relative text-xl sm:text-2xl text-white/90 font-medium max-w-3xl mx-auto animate-fade-in-delay px-4 sm:px-0 leading-relaxed">
              Dal Tagada alla Giostra Avio, dal Trenino per bambini ai Mini Seggiolini: le migliori attrazioni per rendere indimenticabile ogni evento.
            </p>
          </div>
        </div>
        <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:gap-6 animate-fade-in-delay-2 px-4 sm:px-0 justify-center">
          <a
            href="#contatti"
            className="inline-flex items-center justify-center px-10 sm:px-12 py-5 sm:py-6 border-2 border-pink-500 text-lg sm:text-xl font-bold rounded-full text-white bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 hover:scale-105 transform transition-all duration-300 shadow-xl hover:shadow-pink-500/50 backdrop-blur-sm w-full sm:w-auto group relative overflow-hidden hover:border-white/50"
          >
            <span className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform -skew-x-45"></span>
            Contattaci Ora
            <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
          <a
            href="#galleria"
            className="inline-flex items-center justify-center px-10 sm:px-12 py-5 sm:py-6 border-2 border-white/80 text-lg sm:text-xl font-bold rounded-full text-white hover:bg-white/10 hover:scale-105 transform transition-all duration-300 backdrop-blur-sm w-full sm:w-auto group relative overflow-hidden hover:border-pink-500/50 hover:text-pink-100"
          >
            <span className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform -skew-x-45"></span>
            Scopri le Attrazioni
            <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
        </div>
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto px-4 sm:px-0">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white border border-white/20 hover:bg-white/15 transition-colors duration-300">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <h3 className="text-xl font-bold mb-2">Eventi Personalizzati</h3>
            <p className="text-gray-200">Creiamo soluzioni su misura per ogni tipo di evento e budget, con pacchetti personalizzabili.</p>
            <div className="mt-4 flex items-center text-sm">
              <span className="inline-block w-2 h-2 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full mr-2 animate-pulse"></span>
              <span>Preventivi gratuiti</span>
            </div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white border border-white/20 hover:bg-white/15 transition-colors duration-300">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <h3 className="text-xl font-bold mb-2">Assistenza 24/7</h3>
            <p className="text-gray-200">Supporto tecnico e assistenza disponibili in ogni momento, anche nei giorni festivi.</p>
            <div className="mt-4 flex items-center text-sm">
              <span className="inline-block w-2 h-2 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full mr-2 animate-pulse"></span>
              <span>Sempre disponibili</span>
            </div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white border border-white/20 hover:bg-white/15 transition-colors duration-300">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <h3 className="text-xl font-bold mb-2">Sicurezza Garantita</h3>
            <p className="text-gray-200">Tutte le nostre attrazioni sono certificate e assicurate, con controlli regolari.</p>
            <div className="mt-4 flex items-center text-sm">
              <span className="inline-block w-2 h-2 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full mr-2 animate-pulse"></span>
              <span>Certificazioni CE</span>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0">
          <div className="relative h-32">
            <div className="absolute inset-0 flex justify-center">
              <div className="w-1/2 h-full bg-gradient-to-t from-pink-500/20 to-transparent blur-2xl transform -translate-y-1/2"></div>
            </div>
            <div className="absolute inset-x-0 bottom-0 flex justify-center space-x-4">
              <div className="w-3 h-3 rounded-full bg-pink-500 animate-bounce" style={{ animationDelay: '0s' }}></div>
              <div className="w-3 h-3 rounded-full bg-purple-500 animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              <div className="w-3 h-3 rounded-full bg-pink-500 animate-bounce" style={{ animationDelay: '0.4s' }}></div>
            </div>
          </div>
        </div>
        <div className="absolute -bottom-16 -left-16 w-32 h-32 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-float" style={{ animationDelay: '0.3s' }}></div>
        <div className="absolute -bottom-16 -left-32 w-32 h-32 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-float" style={{ animationDelay: '0.6s' }}></div>
      </div>
    </div>
  );
}

export default Hero